import { buildTestId } from '~/utils/buildTestId';

export const ADMIN_USERS_TABS = {
  all: 0,
  byDepartment: 1,
} as const;

const ADMIN_USERS_TABS_LABEL: Record<
  (typeof ADMIN_USERS_TABS)[keyof typeof ADMIN_USERS_TABS],
  string
> = {
  [ADMIN_USERS_TABS.all]: 'All Users',
  [ADMIN_USERS_TABS.byDepartment]: 'By Department',
} as const;

type AdminUsersTabsKey = keyof typeof ADMIN_USERS_TABS;
export type AdminUsersTabsValue =
  (typeof ADMIN_USERS_TABS)[keyof typeof ADMIN_USERS_TABS];

export const AdminUsersTabsConfig = (testID: string) =>
  (Object.keys(ADMIN_USERS_TABS) as AdminUsersTabsKey[]).map((key) => {
    const label = ADMIN_USERS_TABS_LABEL[ADMIN_USERS_TABS[key]];

    return {
      label,
      'aria-label': label,
      testID: buildTestId({ testID, suffix: ['tab', label] }),
    };
  });
